import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { configurationTabs } from './helpers/index';

const ConfigurationTabs = () => <Tabs tabs={configurationTabs} />;

export default ConfigurationTabs;
